<template>
  <div class="row order-bump-container" v-if="!form.deleted">
    <div class="counter">{{ counter }}</div>
    <div class="col-lg-6">
      <bp-select
        v-model="form.product_id"
        id="product-select"
        label="Produto do Order Bump"
        placeholder="Selecione o produto"
        description="Selecione o produto que será oferecido como Order Bump"
        :options="productOptions"
        @input="setProduct"
      />
    </div>

    <div class="col-lg-6">
      <bp-select
        v-model="form.offer_id"
        id="offer-select"
        label="Oferta do Order Bump"
        placeholder="Selecione o produto"
        description="Selecione a oferta do produto de Order Bump"
        :options="options"
        :disabled="!form.product_id"
        @input="setOffer"
        :loading="loading"
      />
    </div>
    <div class="remove-item" @click="removeItem(counter)">
      <i class="fa-light fa-x"></i>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    form: {
      type: Object,
      default: null
    },
    counter: {
      type: Number,
      default: 1
    },
    productId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      orderBumpProduct: null,
      options: [],
      loading: false
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    productOptions() {
      return [
        ...this.products.filter(
          p =>
            p.type_product == "online_course" &&
            p.status == "active" &&
            p.id != this.productId
        )
      ];
    }
  },
  methods: {
    setProduct(value) {
      if (value) {
        this.loading = true;
        this.$store
          .dispatch("offer/getForOrderBump", {
            product_id: value,
            limit: 100
          })
          .then(({ data: { results } }) => {
            this.options = results.filter(
              offer => offer.status === "active" && !offer.is_expired
            );
          })
          .finally(() => (this.loading = false));
      } else {
        this.form.order_bump = "";
        this.setOffer("");
      }

      this.form.product_name = this.products.find(p => p.id == value)?.name;
    },
    setOffer(value) {
      this.form.offer_name = this.options.find(o => o.id == value)?.name;
    },
    removeItem(item) {
      this.$emit("remove", item);
    }
  },
  mounted() {
    if (this.form.product_id) this.setProduct(this.form.product_id);
  }
};
</script>
<style lang="scss" scoped>
.order-bump-container {
  padding: 16px 10px;
  position: relative;
  border: 1px dashed #72aaff;
  border-radius: 4px;
  margin: 0px;

  .counter {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #72aaff;
    border-radius: 50%;
    font-size: 12px;
    top: -10px;
    height: 20px;
    width: 20px;
    background: var(--Surface-Solid-16, #fafbfc);
    box-shadow: 0px 0px 4px 0px #0000001f;
  }
  .remove-item {
    cursor: pointer;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e7373a;
    color: white;
    border-radius: 50%;
    font-size: 10px;
    top: -10px;
    right: 8px;
    height: 20px;
    width: 20px;
    background: #e7373a;
    box-shadow: 0px 0px 4px 0px #0000001f;
  }
}
</style>
